import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { Story } from "./components/sections/Story";
import { Method } from "./components/sections/Method";
import { PainPoints } from "./components/sections/PainPoints";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { Transformation } from "./components/sections/Transformation";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3ii4ro0w5cqo1">
      <MetaPixel data-id="element-1" data-mp="3mjq1tehaqquj" />
      <Hero data-id="element-2" data-mp="3mj6ipufwtwex" />
      <main data-id="element-3" data-mp="3rc9ca2kot5v4">
        <Story data-id="element-4" data-mp="3rbr9so7flver" />
        <Method data-id="element-5" data-mp="3rbzpsoyupgu6" />
        <PainPoints data-id="element-6" data-mp="3rdkl4gszp3t3" />
        <Volumes data-id="element-7" data-mp="3recf5n6xuth9" />
        <Tools data-id="element-8" data-mp="5yjsutqtdfe" />
        <Bonuses data-id="element-9" data-mp="5opww5kum4f" />
        <Offer data-id="element-10" data-mp="682rygdekbl" />
        <Guarantee data-id="element-11" data-mp="4n725ibkvc5" />
        <Testimonials data-id="element-12" data-mp="56qxrrj5tst" />
        <Author data-id="element-13" data-mp="2zl3bdjx5744s" />
        <Transformation data-id="element-14" data-mp="2zllen0i82im7" />
        <Faq data-id="element-15" data-mp="2zmepodo7rua5" />
        <FinalCta data-id="element-16" data-mp="2zmo5j8fjol24" />
      </main>
      <Footer data-id="element-17" data-mp="2znfy0adui2o6" />
      <FloatingCta data-id="element-18" data-mp="33mf0loc3tncg" />
      <PurchasePopup data-id="element-19" data-mp="33lx0uhq8gqzs" />
    </div>;
}